<div [class]="'alert alert-' + alertService.tipo + ' ' + alertService.posizione" [ngClass]="{'bg-white shadow rounded': alertService.posizione == 'sticky'}" role="alert" [hidden]="!alertService.show">
  {{alertService.messaggio}}
</div>
